(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('acuity', {
                parent: 'entity',
                url: '/acuity',
                data: {
                    authorities: [],
                    pageTitle: 'Acuities'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/acuity/list/acuity.html',
                        controller: 'AcuityController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_ACUITY];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_ACUITY, access);
                }]
            });
    }
})();
